import { render, staticRenderFns } from "./TargetBehaviorEditor.vue?vue&type=template&id=56942050&scoped=true&"
import script from "./TargetBehaviorEditor.vue?vue&type=script&lang=js&"
export * from "./TargetBehaviorEditor.vue?vue&type=script&lang=js&"
import style0 from "./TargetBehaviorEditor.vue?vue&type=style&index=0&id=56942050&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56942050",
  null
  
)

export default component.exports